import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Generated class for the AddUserPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-add-user',
  templateUrl: 'add-user.html',
})
export class AddUserPage {

  user: { email: string, usertype_id: string } = {
    email: '',
    usertype_id: '',
  };

  isReadyToSend: boolean;

  public form: FormGroup;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController
    , formBuilder: FormBuilder) {
    this.form = formBuilder.group({
      email: ['', this.emailOrEmpty],
      usertype_id: ['2',this.user.usertype_id]
    });

    // Watch the form for changes, and
    this.form.valueChanges.subscribe((v) => {
      this.isReadyToSend = this.form.valid;
    });
  }

  ionViewDidLoad() {
  }

  cancel() {
    this.viewCtrl.dismiss();
  }

  done() {
    if (!this.form.valid) { return; }
    this.viewCtrl.dismiss({ form: this.form.value, dismiss: 'done' });
  }

  emailOrEmpty(control: AbstractControl): ValidationErrors | null {
    return control.value === ' ' ? null : Validators.email(control);
}

}



// WEBPACK FOOTER //
// ./src/pages/add-user/add-user.ts